import React from 'react';
import { SvgIcon } from '@mui/material';
import { NoSearchResultIconProps } from './NoSearchResultIcon.props';

const FONT_SIZE_MAP = {
  inherit: 'inherit',
  small: 24,
  medium: 40,
  large: 56,
};

export const NoSearchResultIcon: React.FC<NoSearchResultIconProps> = ({
  fontSize = 'medium',
  sx,
  ...props
}) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 56 56"
      sx={{
        fontSize: FONT_SIZE_MAP[fontSize],
        ...sx,
      }}
    >
      <rect width="56" height="56" rx="12" fill="#CBD5E1" fillOpacity="0.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1484 11.4824C17.1542 11.4824 11.4844 17.1523 11.4844 24.1464C11.4844 31.1405 17.1542 36.8104 24.1484 36.8104C31.1425 36.8104 36.8124 31.1405 36.8124 24.1464C36.8124 17.1523 31.1425 11.4824 24.1484 11.4824Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.5129 13.6154C18.4944 13.6154 13.6154 18.4944 13.6154 24.5129C13.6154 30.5314 18.4944 35.4103 24.5129 35.4103C30.5314 35.4103 35.4103 30.5314 35.4103 24.5129C35.4103 18.4944 30.5314 13.6154 24.5129 13.6154ZM11 24.5129C11 17.0499 17.0499 11 24.5129 11C31.9758 11 38.0257 17.0499 38.0257 24.5129C38.0257 31.9758 31.9758 38.0257 24.5129 38.0257C17.0499 38.0257 11 31.9758 11 24.5129Z"
        fill="#A1B0C3"
      />
      <path
        d="M22.5756 28.0771V27.8968C22.5801 27.06 22.6568 26.3943 22.8058 25.8996C22.9593 25.405 23.176 25.0074 23.4559 24.7069C23.7359 24.4017 24.0767 24.1221 24.4785 23.8678C24.7539 23.6921 25 23.5002 25.2167 23.2922C25.4379 23.0795 25.6117 22.8438 25.7381 22.5849C25.8646 22.3214 25.9278 22.0278 25.9278 21.7042C25.9278 21.339 25.8442 21.0223 25.6772 20.7541C25.5102 20.486 25.2844 20.278 25 20.13C24.7201 19.9821 24.4063 19.9081 24.0587 19.9081C23.7381 19.9081 23.4334 19.9798 23.1444 20.1231C22.86 20.2618 22.623 20.4744 22.4333 20.7611C22.2482 21.0431 22.1444 21.4014 22.1218 21.8359H19.7109C19.7335 20.9576 19.9412 20.2225 20.334 19.6307C20.7313 19.039 21.255 18.5952 21.9051 18.2993C22.5598 18.0034 23.2821 17.8555 24.0722 17.8555C24.9345 17.8555 25.693 18.0103 26.3476 18.3201C27.0068 18.6298 27.5192 19.0713 27.8849 19.6446C28.2551 20.2132 28.4402 20.8882 28.4402 21.6695C28.4402 22.1965 28.3567 22.6681 28.1897 23.0842C28.0271 23.5002 27.7946 23.8701 27.4921 24.1937C27.1896 24.5173 26.8307 24.8063 26.4154 25.0605C26.0497 25.2917 25.7494 25.5321 25.5147 25.7817C25.2844 26.0314 25.1129 26.3249 25 26.6624C24.8916 26.9953 24.8352 27.4068 24.8307 27.8968V28.0771H22.5756ZM23.7539 32.4043C23.3476 32.4043 22.9977 32.2564 22.7042 31.9605C22.4108 31.6646 22.264 31.304 22.264 30.8787C22.264 30.4626 22.4108 30.1066 22.7042 29.8108C22.9977 29.5149 23.3476 29.3669 23.7539 29.3669C24.1557 29.3669 24.5034 29.5149 24.7968 29.8108C25.0948 30.1066 25.2438 30.4626 25.2438 30.8787C25.2438 31.1607 25.1738 31.4173 25.0338 31.6484C24.8984 31.8796 24.7178 32.0645 24.4921 32.2032C24.2709 32.3373 24.0248 32.4043 23.7539 32.4043Z"
        fill="#6A7D94"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.3049 32.3049C32.8156 31.7942 33.6435 31.7942 34.1542 32.3049L44.6157 42.7665C45.1264 43.2772 45.1264 44.105 44.6157 44.6157C44.105 45.1264 43.2772 45.1264 42.7665 44.6157L32.3049 34.1542C31.7942 33.6435 31.7942 32.8156 32.3049 32.3049Z"
        fill="#A1B0C3"
      />
    </SvgIcon>
  );
};

export default NoSearchResultIcon;
